// extracted by mini-css-extract-plugin
export default {"list":"contactList_list__7z5z3"};